import { deleteRequest, getRequest, postRequest, putRequest } from "../../../apiClient";
import { ModulesSettingsEndpoint } from "../../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetModulesSettings = async (queryString: any) => {
    var _url = ModulesSettingsEndpoint.MODULES_SETTINGS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetModulesSettingById = async (id: string | number) => {
    var _url = ModulesSettingsEndpoint.MODULES_SETTINGS_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateModulesSettingService = async (param: any) => {
    var res = await postRequest(ModulesSettingsEndpoint.MODULES_SETTINGS_URL, param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditModulesSettingService = async (id: string | number, param: any) => {
    var res = await putRequest(ModulesSettingsEndpoint.MODULES_SETTINGS_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteModulesSettingService = async (id: string | number, param: any) => {
    var _url = ModulesSettingsEndpoint.MODULES_SETTINGS_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};

//#endregion